<template>
  <div>
    <div :style="areaStyle" :class="specialData.swiperWrap==2?'swiper-container-one': 'swiper-container'" >
      <van-swipe
        :autoplay="specialData.swiperSpeed?specialData.swiperSpeed:autoplay"
        :stop-propagation="stopPropagation"
        indicator-color="white">
        <van-swipe-item
          v-for="(item, index) in specialEntryList"
          :key="index"
          :style="imgStyle">
          <a @click="jumpUrl(item)">
            <img v-if="item.thumbnail" :src="item.thumbnail" class="img-main" :alt="item.swiperTitle">
            <img v-else :src="defaultImg" class="img-main" :alt="item.swiperTitle">
            <h3 class="swiper-title" v-if="specialData.swiperTitleStatus">{{item.swiperTitle}}</h3>
          </a>
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>
<script>
import defaultImg from '../asset/images/default-img.png'
import {commonClickFn} from './clickJs'
export default {
  name: "Carousel",
  props: {
    data: {
      type: Object
    },
  },
  data() {
    const { tempData: { specialData, specialStyle, specialEntryList = []}, terminal } = this.data
    return {
      defaultImg,
      autoplay: 3000,
      stopPropagation: false,//阻止滑动跳转
      specialData,
      specialStyle,
      specialEntryList,
      terminal,
    };
  },
  mounted() {
    this.getImageInfoList(this.specialEntryList)
  },
  computed: {
    areaStyle() {
      const {
        blockMargeTop,
        blockMargeBottom,
        blockBGClolor
      } = this.specialStyle;
      return {
        marginTop: `${blockMargeTop ? blockMargeTop : 0}px`,
        marginBottom: `${blockMargeBottom ? blockMargeBottom : 0}px`,
        backgroundColor: blockBGClolor ? blockBGClolor : 'none',
      }
    },
    swiperWidth(){
      const {
        swiperWrap
      } =  this.specialStyle;
      return {
        width: swiperWrap==2?'100%':'18.72rem!important',
      }
    },
    imgStyle(){
      const {
        imgRadius=false,
        imgShadow=false,
        imgBorder=false,
        imgBorderColor='',
        imgBackgroundColor='',
      } =  this.specialStyle;
      return {
        backgroundColor: imgBackgroundColor?imgBackgroundColor:'',
        borderRadius: imgRadius?'4px':'',
        boxShadow: imgShadow?'0px 0px 16px 0px rgba(0, 0, 0, 0.1)':'',
        border: imgBorder?`1px solid ${imgBorderColor}`:'none'
      }
    }
  },
  methods: {
    // 数组处理 通过图片id 视频id 请求最新的图片地址 视频地址
    getImageInfoList(articleDataList){
      let idList = []
      articleDataList.map((item)=>{
        idList.push(item.id)
      })
      console.log(idList,'fsdfasdfasdf')
      this.$apis.cms.getImageList(idList).then(res=>{
        let ImageInfoList = res.data
        articleDataList.map((item,index)=>{
          ImageInfoList[index]&&(item.thumbnail = ImageInfoList[index].thumbnail)
        })
      })
    },

    //跳转
    jumpUrl(item){
      commonClickFn(item,this.specialData,this,true)
    },

  },
};
</script>
<style lang="less" scoped>
.img-main {
  width: 100%;
  height: 100%;
}

.swiper-container-one{
  width: 750px!important;
  height: 320px;
  z-index: 0!important;
  .swiper-title {
    color: #fff;
    font-size: 26px;
    opacity: 0.75;
    margin: 0;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 80px;
    line-height: 80px;
    background: rgba(0, 0, 0, 0.5);
    padding: 0 24px;
    box-sizing: border-box;
    text-align: left;
  }
  /deep/ .swiper-container{
    z-index: 0!important;
  }
  /deep/ .van-swipe__indicator{
    background-color: #fff!important;
    opacity: 1!important;
  }
  /deep/ .van-swipe__indicator.van-swipe__indicator--active{
    background-color: #1989fa!important;
  }

}
.swiper-container {
  //margin: 24px 0;
  width: 702px!important;
  max-height: 320px;
  z-index: 0!important;
  .swiper-title {
    color: #fff;
    font-size: 26px;
    opacity: 0.75;
    margin: 0;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 80px;
    line-height: 80px;
    background: rgba(0, 0, 0, 0.5);
    padding: 0 24px;
    box-sizing: border-box;
    text-align: left;
  }
  /deep/ .swiper-container{
    z-index: 0!important;
  }
  /deep/ .van-swipe__indicator{
    background-color: #fff!important;
    opacity: 1!important;
  }
  /deep/ .van-swipe__indicator.van-swipe__indicator--active{
    background-color: #1989fa!important;
  }
}
</style>
<style>
/deep/ .swiper-container{
  z-index: 0!important;
}
.swiper-container{
  z-index: 0!important;
}
</style>
